import on from '../util/Elements/on'

export default function (Site, $) {
  Site.widget('limit-height', {
    _create () {
      this.update()
      
      this.offResize = on(
        $(window),
        'resize',
        () => this.update()
      )
    },
    _transitionIn () {
      this.update()
    },
    _destroy () {
      this.offResize()
    },
    update () {
      const container = this.element
      const height = this.element.data('height')
      const width = this.element.data('width')
      const ratio = height / width;

      const isHorizontal = ratio > (307 / 380)

      container.find("img").parent().height(
        isHorizontal
          ? container.find("img").width() * (307 / 380)
          : container.find("img").width() * (512 / 768)
      )
    }
  })
}